import axios from 'axios';
import factory from './src/factory.js';
export { HTTPServerError } from './src/errors.js';
export { handleUriCreation } from './src/makeUri.js';

axios.defaults.validateStatus = void 0;
const http = factory(axios.request.bind(axios));
const { get, del, head, post, put, patch, makeUri, configure, interceptors } = http;

export { configure, http as default, del, get, head, interceptors, makeUri, patch, post, put };
